import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { Butterfly } from "@/components/site/LogoMark";

const OrderConfirmation = () => {
  const { orderNo } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => {
    api.get(`/orders/${orderNo}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderNo]);

  if (!order) return <div className="pt-40 pb-32 max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 text-sm text-ink/60">Fetching your order…</div>;

  return (
    <div className="pt-32 md:pt-40 pb-32" data-testid="order-confirmation-page">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="mb-16 flex items-center gap-4">
          <Butterfly size={36} />
          <div className="nav-item">Order received</div>
        </div>
        <h1 className="serif text-5xl md:text-6xl mb-6" data-testid="order-thanks">Thank you, {order.customer.name.split(" ")[0]}.</h1>
        <p className="text-ink/80 leading-relaxed text-lg max-w-[64ch]">
          Order <span className="serif">{order.order_no}</span> is with us. We dispatch within 5 days. A confirmation
          is on its way to <span className="text-ink">{order.customer.email}</span>.
        </p>

        <div className="mt-16 grid md:grid-cols-2 gap-12">
          <div className="hairline p-6">
            <div className="serif text-2xl mb-6">Your pieces</div>
            <ul className="space-y-4">
              {order.items.map((i, idx) => (
                <li key={idx} className="flex gap-3">
                  <img src={imgUrl(i.image)} alt={i.name} className="w-16 h-20 object-cover" />
                  <div className="flex-1 text-sm">
                    <div className="serif text-base leading-tight">{i.name}</div>
                    <div className="text-xs text-ink/60">Size {i.size} · Qty {i.qty}{i.is_pair ? " · Pair" : ""}</div>
                  </div>
                  <div className="text-sm">₹{i.line_total.toLocaleString("en-IN")}</div>
                </li>
              ))}
            </ul>
            <div className="hairline-t mt-6 pt-4 space-y-2 text-sm">
              <div className="flex justify-between"><span>Subtotal</span><span>₹{order.subtotal.toLocaleString("en-IN")}</span></div>
              <div className="flex justify-between text-ink/70"><span>Shipping</span><span>{order.shipping === 0 ? "Free" : `₹${order.shipping}`}</span></div>
              <div className="flex justify-between text-base pt-2"><span>Total</span><span className="serif text-xl">₹{order.total.toLocaleString("en-IN")}</span></div>
            </div>
          </div>
          <div className="hairline p-6">
            <div className="serif text-2xl mb-6">Ships to</div>
            <div className="text-sm text-ink/80 leading-relaxed">
              {order.customer.name}<br />
              {order.customer.address_line1}<br />
              {order.customer.address_line2 && <>{order.customer.address_line2}<br /></>}
              {order.customer.city}, {order.customer.state} {order.customer.pincode}<br />
              {order.customer.phone}
            </div>
            <div className="mt-6 nav-item text-ink/60">Payment</div>
            <div className="text-sm mt-2">{order.payment_mode === "cod" ? "Cash on delivery" : "Razorpay (stub)"}</div>
          </div>
        </div>

        <div className="mt-16">
          <Link to="/shop" className="btn-ink">Keep browsing</Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
